import { TAction } from '../actions/types/action';
import {
  SET_PUSH_PERMISSION_STATE,
  SET_PUSH_SUPPORTED,
  SET_PUSH_INITIALIZED,
  SET_PUSH_SUBSCRIPTION,
  SET_PUSH_TOPICS,
  SET_PUSH_LOADING,
  SET_PUSH_ERROR,
  SET_PUSH_LINKED,
  ADD_PUSH_TOPIC,
  REMOVE_PUSH_TOPIC,
  RESET_PUSH_STATE,
  IPushSubscriptionState
} from '../actions/pushNotificationActionCreator';
import { IPushTopicSubscription } from '../services/pushNotificationApiService';

export interface IPushNotificationState {
  isSupported: boolean;
  isInitialized: boolean;
  permissionState: NotificationPermission;
  subscription: IPushSubscriptionState | null;
  topics: IPushTopicSubscription[];
  isLoading: boolean;
  error: string | null;
}

const defaultState: IPushNotificationState = {
  isSupported: false,
  isInitialized: false,
  permissionState: 'default',
  subscription: null,
  topics: [],
  isLoading: false,
  error: null
};

export default function pushNotificationReducer(
  state: IPushNotificationState = defaultState,
  action: TAction<any>
): IPushNotificationState {
  switch (action.type) {
    case SET_PUSH_SUPPORTED: {
      return {
        ...state,
        isSupported: action.payload
      };
    }

    case SET_PUSH_INITIALIZED: {
      return {
        ...state,
        isInitialized: action.payload
      };
    }

    case SET_PUSH_PERMISSION_STATE: {
      return {
        ...state,
        permissionState: action.payload
      };
    }

    case SET_PUSH_SUBSCRIPTION: {
      return {
        ...state,
        subscription: action.payload,
        error: null
      };
    }

    case SET_PUSH_TOPICS: {
      return {
        ...state,
        topics: action.payload
      };
    }

    case SET_PUSH_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      };
    }

    case SET_PUSH_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }

    case SET_PUSH_LINKED: {
      if (!state.subscription) {
        return state;
      }
      return {
        ...state,
        subscription: {
          ...state.subscription,
          isLinked: action.payload
        }
      };
    }

    case ADD_PUSH_TOPIC: {
      const exists = state.topics.some((t) => t.topic === action.payload.topic);
      const topics = exists
        ? state.topics.map((t) => (t.topic === action.payload.topic ? action.payload : t))
        : [...state.topics, action.payload];
      return { ...state, topics };
    }

    case REMOVE_PUSH_TOPIC: {
      const filtered = state.topics.filter((t) => t.topic !== action.payload);
      if (filtered.length === state.topics.length) {
        return state;
      }
      return { ...state, topics: filtered };
    }

    case RESET_PUSH_STATE: {
      return defaultState;
    }

    default:
      return state;
  }
}
